// extracted by mini-css-extract-plugin
export default {"MainContainer":"SignUp_MainContainer__3Goru","Form":"SignUp_Form__Le1U9","SubmitButton":"SignUp_SubmitButton__PiqC-"};